import { useEffect } from "react";
import { StyledEditBtn } from "./style";
import { Icons } from "contents/icons";
/**
 * 토글 스위치 컴포넌트 속성
 */
interface EditBtnProps {
  size: "large" | "medium" | "small";
  type: "add" | "subtract" | "delete";
  disabled?: boolean;
  className?: string;
  tabIndex?: number;
  /** 이벤트 핸들러 */
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /** 이벤트 핸들러 */
  onMouseDown?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /** 이벤트 핸들러 */
  onMouseUp?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /** 이벤트 핸들러 */
  onMouseEnter?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /** 이벤트 핸들러 */
  onMouseLeave?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /** 마운트 핸들러 */
  onMount?: () => void;
  /** 언마운트 핸들러 */
  onUnmount?: () => void;
}

/**
 * Add Button component
 * @author hc_yang
 * @param {EditBtnProps} param
 * @returns JSX.Element
 */
export const EditBtn = ({
  size,
  type,
  disabled = false,
  className,
  tabIndex = 0,
  onClick,
  onMouseDown,
  onMouseUp,
  onMouseEnter,
  onMouseLeave,
  onMount,
  onUnmount,
}: EditBtnProps) => {
  useEffect(() => {
    onMount && onMount();
    return () => {
      onUnmount && onUnmount();
    };
  }, []);
  return (
    <StyledEditBtn
      $type={type}
      $size={size}
      $disabled={disabled}
      className={className}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      tabIndex={tabIndex}
    >
      {type === "add" && <Icons.Plus className="icon" />}
      {type === "subtract" && <Icons.Minus className="icon" />}
      {type === "delete" && <Icons.XCloseLg className="icon" />}
    </StyledEditBtn>
  );
};
